import { loadTranslations } from '@/services/translations';

const translations = {
  data() {
    return {
      languages: [
        {
          id: 'bs',
          title: 'Bosanski',
          flag: 'ba',
          shortTitle: 'bs',
        },
        {
          id: 'hr',
          title: 'Hrvatski',
          flag: 'hr',
          shortTitle: 'hr'
        },
        {
          id: 'en',
          title: 'English',
          flag: 'us',
          shortTitle: 'en'
        }
      ],
      // selectedLang: localStorage.getItem('langId') || 'bs'
      selectedLang: 'bs'
    };
  },
  computed: {
    lang() {
      return this.languages.find(item => item.id === this.selectedLang);
    },
    translations() {
      return loadTranslations(this.selectedLang);
    },
  },
  methods: {
    setLanguage(langId) {
      if (langId === this.selectedLang) return;
      const lang = this.languages.find(item => item.id === langId);
      this.selectedLang = lang.id || 'bs'
      localStorage.setItem('langId', this.selectedLang);
      location.reload();
    },
  },
}

export default translations;